// JsFromRoutes CacheKey 207be7d46c7ffd818fe82e989982cbe8
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/admin/ledger_accounts_v2'),
}
